export type UserInfo = {
    address: string;
    new_address: string;
    is_authorized: boolean;
    id: number;
    nickname: string;
    profile_image: string;
    whisper_image: number;
    description: string;
    kyc_status: boolean;
    kyc_application_id: number;
    token: {
        access: {
            token: string,
            expires: string,
        },
    },
}

export const defaultUserInfo = {
    address: '',
    new_address: '',
    is_authorized: false,
    id: 0,
    nickname: '',
    profile_image: '',
    whisper_image: 0,
    description: '',
    kyc_status: false,
    kyc_application_id: 0,
    token: {
        access: {
            token: '',
            expires: '',
        },
    },
}
